import { z } from 'zod';

/**
 * Parse an AG Grid filter model against a Zod object schema column-by-column.
 * Valid columns are kept; invalid columns are dropped with a console warning.
 * Avoids the all-or-nothing behaviour of a top-level `schema.safeParse` which
 * would discard every filter when one column fails (e.g. unfamiliar AG Grid
 * shape).
 */
export function parseFilterModelPerKey<S extends z.ZodObject<z.ZodRawShape>>(
  schema: S,
  model: Record<string, unknown>
): Partial<z.infer<S>> {
  const result: Record<string, unknown> = {};
  for (const key in schema.shape) {
    const value = model[key];
    if (value === undefined) continue;
    const parsed = z.safeParse(schema.shape[key], value);
    if (parsed.success) {
      if (parsed.data !== undefined) result[key] = parsed.data;
    } else {
      console.warn(`Dropping invalid filter "${key}"`, parsed.error.format());
    }
  }
  return result as Partial<z.infer<S>>;
}
